import { CargoCategory as ServerCargoCategory } from 'server/models/CargoCategory';

export * from 'server/models/CargoCategory';

export class CargoCategory extends ServerCargoCategory {
    /** A comparator function for CargoCategories. */
    static DisplayOrder(c1 : CargoCategory, c2 : CargoCategory) {
        let cmp : number;
        return (cmp = c1.DisplayOrder() - c2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            c1.Id() - c2.Id() :
            cmp;
    }
}



// WEBPACK FOOTER //
// ./data/models/CargoCategory.ts